export function separateLines(line, length) {
    let array = line.split(' ')
    /* ================== */
    let ret_array = []
    let counter = 0
    let str = ''
    /* ================== */
    for (let word of array) {
        if (counter < length) {
            str += word + ' '
            counter += word.length
        } else {
            str += word
            ret_array.push(str)
            counter = 0
            str = ''
        }
    }
    return ret_array
}

export function getLengthByWidth(width) {
    return Math.round(width/28)

}

export function makeAbbr(words) {
    return words
        .split(' ')
        .reduce((prevVal, curWord) => prevVal + (curWord ? curWord[0]: ''), '')
        .toUpperCase()
}

export function shuffle(array) {
    let tmp = JSON.stringify(array)
    tmp = JSON.parse(tmp)
    return tmp.sort(() => Math.random() - 0.5)
}

export function initials(str) {
    return str.split(/\s+/).map((w,i) => i ? w.substring(0,1).toUpperCase() + '.' : w).join(' ');
}

export function morph(length, words) {
    return words[(length % 100 > 4 && length % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(length % 10 < 5) ? length % 10 : 5]];
}

export function sname_initials (str) {
    if (str) return str.split(/\s+/).map((w,i) => i ? w.substring(0,1).toUpperCase() + '.' : w).join(' ');
    return str
}

export function get_status_color(status) {
    switch (status) {
        case '1. В работе (в графике)': return 'green'
        case '0. На обработке': return 'amber-darken-2'
        case '0. Зарегистрировано': return 'deep-orange'
        case '1. В ожидании (Ресурса)': return 'teal-darken-2'
        case '1. В ожидании (Заказчика)': return 'grey-darken-2'
        case '2. Отклонено': return 'blue'
        case '2. Решено':
        case '2. Закрыто':
            return 'grey-lighten-2'
        case '2. Отложено заказчиком':
            return 'black'
        default: return 'grey'
    }
}

export function dataURLtoFile(dataurl, filename) {
    let arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type:mime});
}
